/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/


import axios from 'axios';
import { history } from '../helpers';

/**
 * Get auth object from local storage
 */

const getAuth = () => {
  const authData = localStorage.getItem('reorgjwt');
  let auth = ""
  if (authData && Object.keys(authData).length > 0) {
    auth = authData ? JSON.parse(authData)?.token : null; 

  } 
  return auth;

}
/**
 * Create axios instance.
 *
 * @type {AxiosInstance}
 */

const auth = getAuth();
const axiosInstance = (() => {
  const params = {};
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };
  if (auth) {
    Object.assign(headers, { Authorization: `Bearer ${auth}` });
  }

  axios.defaults.headers.common.Authorization = `Bearer ${auth}`;
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    params: params,
    headers: headers
  });
})();

axiosInstance.interceptors.request.use(
  function (config) {
    const token = getAuth();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  function (error) {

    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  data => {
    return Promise.resolve(data);
  },
  error => {
    console.log('error', error.response)
    console.log('error', error?.response?.status === 401 && history.location.pathname !== '/login' && history.location.pathname !== '/register')

    if (error?.response?.status === 401 && history.location.pathname !== '/login' && history.location.pathname !== '/register') {
      delete axios.defaults.headers.Authorization;
      localStorage.clear()
      window.location.reload(true)
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
